import React, { Component } from 'react';

import {
  Container
} from 'reactstrap';
import Logo from '../components/Logo';


class BlankLogoPage extends Component {
  
  render() {
    const { noclick } = this.props;
    return (
      <Container fluid className="blank-logo-page">
        <h3 className="text-center logo-container"><Logo {...{noclick}} /></h3>
        {this.props.children}
      </Container>
    );
  }
}


export default BlankLogoPage;


// WEBPACK FOOTER //
// ./src/containers/BlankLogoPage.js